import './App.css';
import './global-overrides.css';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { useTheme } from 'glintly-ui';
import { GlobalCssTheme } from './constant/theme';
import { UserNavbar } from './components/navbar';
import Footer from './components/footer';
import SalonsPage from './pages/salons';
import SalonView from './pages/salons/salon-view';
import ServicesPage from './pages/services';
import SalonServices from './pages/services/SalonServices';
import ProductDetail from './pages/services/ProductDetail';
import Cart from './pages/cart';
import NotFound from './pages/not-found';
import ProfilePage from './pages/profile';
import BookingsPage from './pages/bookings';
import AboutUsPage from './pages/about';
import ContactPage from './pages/contact';
import PrivacyPolicyPage from './pages/legal/privacy';
import TermsOfServicePage from './pages/legal/terms';
import RefundPolicyPage from './pages/legal/refund';
import SitemapPage from './pages/sitemap';
import HomePage from './pages/home';
import { ToastContainer } from 'react-toastify';
import BackendStatusBar from './components/BackendStatusBar';
import { LocationPreferenceProvider } from './contexts/LocationPreferenceContext';
import Seo from './components/Seo';

/** Old URLs: /services/service/:id → /services/:id */
function LegacyServiceProductRedirect() {
  const { id } = useParams();
  return <Navigate to={`/services/${id}`} replace />;
}

function App() {
  const { theme } = useTheme();
  const token = useSelector((s) => s.auth?.token);

  useEffect(() => {
    if (token) localStorage.setItem('token', token);
  }, [token]);

  return (
    <div
      style={{
        ...GlobalCssTheme(theme),
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <BackendStatusBar />
      <LocationPreferenceProvider>
        <Seo />
        <UserNavbar />
        <ToastContainer />
        <main
          style={{
            padding: 'calc(var(--navbar-height, 3.75rem) + var(--backend-banner-height, 0px)) 0 0',
            position: 'relative',
            zIndex: 'var(--z-base)',
            minWidth: 0,
            maxWidth: '100%',
          }}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/femalepage" element={<Navigate to="/?gender=female" replace />} />
            <Route path="/femalePage" element={<Navigate to="/?gender=female" replace />} />
            <Route path="/female" element={<Navigate to="/?gender=female" replace />} />
            <Route path="/salons" element={<SalonsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/orders" element={<Navigate to="/profile" replace />} />
            <Route path="/salon/:id" element={<SalonView />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/salon/:salonId" element={<SalonServices />} />
            <Route path="/services/service/:id" element={<LegacyServiceProductRedirect />} />
            <Route path="/services/salon" element={<Navigate to="/salons" replace />} />
            <Route path="/services/:id" element={<ProductDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/bookings" element={<BookingsPage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            <Route path="/term" element={<TermsOfServicePage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/terms-and-conditions" element={<TermsOfServicePage />} />
            <Route path="/refund" element={<RefundPolicyPage />} />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
            <Route path="/sitemap" element={<SitemapPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </LocationPreferenceProvider>
    </div>
  );
}

export default App;
